export const getCompensationValues = (model, percentage, value) => {
  if (model === 1) return ["BRW-PAID", "BRW-PAID"];
  const compPercentage = percentage ? Number(percentage).toFixed(3) : "N/A";
  const compValue = value ? `$${Number(value).toFixed(2)}` : "N/A";
  return [compPercentage, compValue];
};
